<template>
  <div class="page-with-subnav">
    <app-sub-navigation-bar
      back-label="Back to all discounts"
      @back="$router.push('/settings/account')"
    />
    <div class="main-container page-with-subnav__content">
    <div class="ui grid discount-form-grid">
      <div class="sixteen wide column">
        <h1 class="discount-form-heading">
          <img src="../../assets/img/icn_discount.svg" alt="" class="discount-form-heading-icon" width="32" height="32">
          {{ pageTitle }}
        </h1>
      </div>
      <div class="sixteen wide column">
        <app-form-error></app-form-error>
        <form class="ui form discount-form-inner" @submit.prevent="saveDiscount">
          <h4 class="ui dividing header">Details</h4>
          <div class="field settings">
            <label>Title*</label>
            <app-text-input type="text" v-model="discountForm.title" placeholder="E.g. 10% OFF" />
            <div class="discount-field-hint">Customers will see this on quotes.</div>
          </div>
          <div class="field settings">
            <label>Description</label>
            <app-text-input type="text" v-model="discountForm.description" placeholder="Enter a short description" />
          </div>
          <div class="field settings">
            <label>Type*</label>
            <app-select
              :defaultLabel="'Select type'"
              :items="discountTypeOptions"
              :value="discountForm.type"
              @selected="discountForm.type = $event.id">
            </app-select>
          </div>
          <div class="field settings">
            <label>Amount</label>
            <div class="ui right labeled input" v-if="discountForm.type === 'percentage'">
              <input class="discount-amount-input" type="number" step="0.01" min="0" v-model="discountForm.amount">
              <div class="ui label">%</div>
            </div>
            <div class="ui left labeled input" v-else>
              <label class="ui label">$</label>
              <input class="discount-amount-input" type="number" step="0.01" min="0" v-model="discountForm.amount">
            </div>
          </div>
          <div class="field discount-form-actions">
            <button type="submit" class="ui primary button">Save Changes</button>
            <button type="button" class="ui negative basic button" v-if="discountForm.id" @click="deleteDiscount">Delete</button>
          </div>
        </form>
      </div>
    </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import auth from '../../helpers/auth'
import SubNavigationBar from '../../components/common/SubNavigationBar.vue'

export default {
  name: 'DiscountForm',
  components: {
    'app-sub-navigation-bar': SubNavigationBar
  },
  data () {
    return {
      discountForm: {
        id: null,
        title: '',
        description: '',
        type: 'percentage',
        amount: ''
      },
      discountTypeOptions: [
        { id: 'percentage', name: 'Percentage' },
        { id: 'amount', name: 'Dollar amount' }
      ]
    }
  },
  computed: {
    isNew () {
      return this.$route.name === 'DiscountNew'
    },
    pageTitle () {
      return this.isNew ? 'New Discount' : 'Edit Discount'
    }
  },
  watch: {
    '$route' () {
      this.bootstrapFromRoute()
    }
  },
  created () {
    auth.check(this)
    this.bootstrapFromRoute()
  },
  methods: {
    bootstrapFromRoute () {
      if (this.isNew) {
        this.discountForm = { id: null, title: '', description: '', type: 'percentage', amount: '' }
        return
      }
      const id = this.$route.params.id
      if (!id) return
      axios.get(`/api/discounts/${id}`).then((res) => {
        const d = res.data && res.data.discount
        if (!d) {
          this.errorNotification('Discount not found')
          this.$router.replace('/settings/account')
          return
        }
        this.discountForm = {
          id: d.id,
          title: d.title || '',
          description: d.description || '',
          type: d.type || 'percentage',
          amount: d.amount != null ? String(d.amount) : ''
        }
      }).catch(() => {
        this.errorNotification('Failed to load discount')
        this.$router.replace('/settings/account')
      })
    },
    saveDiscount () {
      const payload = {
        title: this.discountForm.title,
        description: this.discountForm.description,
        type: this.discountForm.type,
        amount: Number(this.discountForm.amount) || 0
      }
      const req = this.discountForm.id
        ? axios.put(`/api/discounts/${this.discountForm.id}`, payload)
        : axios.post('/api/discounts', payload)
      req.then(() => {
        this.successNotification('Discount saved')
        this.$router.push('/settings/account')
      }).catch((error) => {
        const msg = (error.response && error.response.data && error.response.data.error) || 'Failed to save discount'
        this.errorNotification(msg)
      })
    },
    deleteDiscount () {
      if (!this.discountForm.id) return
      axios.delete(`/api/discounts/${this.discountForm.id}`).then(() => {
        this.successNotification('Discount deleted')
        this.$router.push('/settings/account')
      }).catch(() => {
        this.errorNotification('Failed to delete discount')
      })
    }
  }
}
</script>

<style scoped>
.page-with-subnav__content.main-container {
  margin-top: 16px;
}
.discount-form-grid {
  max-width: 680px;
  margin-left: 0;
  margin-right: 0;
}
.discount-form-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 0;
  color: #323C47;
}
.discount-form-heading-icon {
  flex-shrink: 0;
}
.discount-form-inner {
  width: 100%;
}
@media (min-width: 768px) {
  .discount-form-inner {
    max-width: none;
  }
}
.discount-field-hint {
  margin-top: 6px;
  font-size: 13px;
  color: var(--color-mid-grey);
}
.discount-form-actions {
  margin-top: 1rem;
}
.discount-form-actions .button + .button {
  margin-left: 0.5rem;
}
.discount-amount-input[type='number']::-webkit-inner-spin-button,
.discount-amount-input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.discount-amount-input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
